import styled from 'styled-components';
import {dFlexCenter, mobileMedia} from '../../../../../globalVariables/GlobalVariables';

export const actionsBar = styled.div`
    ${dFlexCenter};
    padding: var(--space-xl) var(--space-md);
    gap: var(--space-lg);
    background: var(--TA-color-bg-base);
    border-top: 1px solid var(--TA-color-border-subtle);
    ${mobileMedia} {
        margin: 0 var(--space-lg) var(--space-3xl);
        border: 1px solid rgba(45, 28, 28, 0.1);
        border-radius: 0 0 var(--radius-xl) var(--radius-xl);
    }
`;
